<template>
  <div class="opentok-instream-setup">
    <div class="p-3">
      <div id="video" class="d-flex align-items-center justify-content-center">
        <video
          v-show="streamingProps.videoEnabled"
          ref="video"
          class="video mx-auto"
          prevent-right-click
          autoplay="true"
          playsinline="true"
        ></video>
        <div v-if="!streamingProps.videoEnabled" class="empty-video">
          <i class="fal fa-video-slash h1 c-charcoal"></i>
        </div>
      </div>
      <OpenTokHWSetupForm
        v-if="stream"
        :stream="stream"
        :availableVideoDevices="availableVideoDevices"
        :availableAudioInputDevices="availableAudioInputDevices"
        :availableAudioOutputDevices="availableAudioOutputDevices"
      />
    </div>
  </div>
</template>

<script>
import OT from '@opentok/client';
import _ from 'lodash';
import OpenTokHWSetupForm from './OpenTokHWSetupForm';
import { mapGetters } from 'vuex';

export default {
  name: 'OpenTokInStreamSetup',
  components: { OpenTokHWSetupForm },
  props: ['stream'],
  computed: {
    ...mapGetters({
      streamingProps: 'setting/streamingProps',
    }),
  },
  data() {
    return {
      availableVideoDevices: [],
      availableAudioInputDevices: [],
      availableAudioOutputDevices: [],
    };
  },
  methods: {
    shortenDeviceLabel(label) {
      return label.replace(/ \(\w+:\w+\) */g, '');
    },
    mapDevice(device) {
      return {
        label: this.shortenDeviceLabel(device.label),
        deviceId: device.deviceId,
      };
    },
    async getDeviceInfo() {
      OT.getDevices((error, devices) => {
        if (error) {
          console.error('Failed to enumerate media devices: ', error);
        } else {
          this.availableVideoDevices = devices
            .filter(device => device.kind?.toLowerCase() === 'videoinput')
            .map(this.mapDevice);
          this.availableAudioInputDevices = devices
            .filter(device => device.kind?.toLowerCase() === 'audioinput')
            .map(this.mapDevice);
          this.availableAudioOutputDevices = devices
            .filter(device => device.kind?.toLowerCase() === 'audiooutput')
            .map(this.mapDevice);
          const devicesPayload = {
            videoDevices: this.availableVideoDevices,
            audioInputDevices: this.availableAudioInputDevices,
            audioOutputDevices: this.availableAudioOutputDevices,
          };
          this.$emit('devicesLoaded', devicesPayload);
        }
      });
    },
    async start() {
      await this.getDeviceInfo();
      this.gotStream();
    },
    async gotStream() {
      const videoElement = this.$refs['video'];
      await this.getDeviceInfo();
      videoElement.srcObject = this.stream;
    },
  },
  async mounted() {
    await this.start();
  },
  watch: {
    stream(value) {
      this.gotStream();
    },
  },
};
</script>

<style lang="scss">
@import '@/web/styles/components-variables.scss';

.opentok-instream-setup {
  background-color: white;
  border: 1px solid $light-gray;
  z-index: 1001;
  overflow: hidden;
  width: auto;
  max-width: 100%;
  margin-top: 30px;

  #video {
    max-width: 100%;
    max-height: 250px;

    .video {
      max-width: 100%;
      height: 250px;
      transform: scale(-1, 1);
      transform-origin: 50% 50%;
    }

    .empty-video {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: $white;
      width: 100%;
      height: 350px;
      max-height: 100%;
    }
  }

  .contain-mode-select,
  .toggle-video,
  .toggle-audio,
  .advanced-audio-processing-select {
    display: none !important;
  }
}
</style>
